// extracted by mini-css-extract-plugin
export var detailsGdd = "detailsGdd-module--details-gdd--c14d8";
export var preLink = "detailsGdd-module--pre-link--89568";